// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - AreaMCP
export class AreaMCP {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /**
     * Retrieves an MCP stream by ID. Users can only access MCP streams associated with themselves.
     * @param streamId - The ID of the MCP stream to retrieve.
     * @returns The MCPStream object.
     */
    async getMCPStream(streamId) {
        return this.dataCore.getMCPStream(streamId);
    }
    /**
     * Retrieves the user's MCP stream. If no MCP stream exists for the user, an empty MCP stream is created automatically.
     * @returns The user's MCPStream object.
     */
    async getUserMCPStream() {
        return this.dataCore.getUserMCPStream();
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Write
    /**
     * Updates the user's MCP stream with the provided data.
     * @param data - The update input containing optional projectFeatureId and projectDocumentId.
     * @returns The updated MCPStream object.
     */
    async updateUserMCPStream(data) {
        return this.dataCore.updateUserMCPStream(data);
    }
}
